export const support_request_types = [
  { value: 'voli__cambiare_o_annullare_il_volo', text: 'Cambiare o annullare il volo' },
  { value: 'voli__bagagli__posti_e_altri_servizi', text: 'Bagagli, posti e altri servizi' },
  { value: 'voli__pagare_col_welfare_o_con_card', text: 'Pagare col welfare o con card' },
  { value: 'voli_il_volo_è_cambiato_o_cancellato', text: 'Il volo è cambiato o cancellato' },
  { value: 'voli_check-in_e_carta_d_imbarco', text: 'Check-in e carta d\'imbarco' },
  { value: 'voli__assistenza_per_disabilità_o_mobilità', text: 'Assistenza per disabilità o mobilità' },
  { value: 'voli_problemi_con_il_sito', text: 'Problemi con il sito' },
  { value: 'voli_altro', text: 'Altro' },
]

export const support_contacts = {
  confirmcode_prefix: 'BLF',
  intro: '<strong>Il form online è il canale più veloce</strong> per richiedere informazioni, modifiche, rimborsi o servizi extra. Compila il form e riceverai risposta da un nostro operatore.<br />In caso di emergenza in aeroporto o problemi d’imbarco fuori orario, rivolgiti al desk della compagnia aerea e inviaci una segnalazione tramite il form.',
  channels_text: 'Per partenze entro 48 ore, contattaci telefonicamente dal <strong>lunedì al venerdì, dalle 9:00 alle 18:00</strong>.<br />In caso di emergenza in aeroporto o problemi d’imbarco fuori orario, rivolgiti al desk della compagnia aerea e segnala comunque la richiesta tramite il form.',
  phone_caption: 'Lun – Ven, 9:00 – 18:00',
}
